import React, { forwardRef, Ref, ReactElement } from 'react';
import {
  // Backdrop,
  // Paper,
  Grid,
  CircularProgress,
  DialogContent,
  Dialog,
  Typography,
  Slide,
  BackdropProps,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import useStyles from './styles';

const Transition = forwardRef(function Transition(
  props: TransitionProps & { children?: ReactElement<any, any> },
  ref: Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LoadingDialog: React.FC<BackdropProps> = ({ open }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      maxWidth="sm"
      // classes={{ paper: classes.paperRoot }}
    >
      <DialogContent className={classes.paperBackDrop}>
        <Grid
          container
          alignContent="center"
          direction="column"
          style={{ padding: '100px' }}
        >
          <CircularProgress className={classes.circularProgressBackDrop} />
          <Typography className={classes.typographyBackdrop}>
            Aguarde...
          </Typography>
        </Grid>
      </DialogContent>
    </Dialog>

    // <Backdrop open={open} className={classes.backdrop}>
    //   <Paper className={classes.paperBackDrop}>
    //     <Grid
    //       container
    //       alignContent="center"
    //       direction="column"
    //       style={{ padding: '100px' }}
    //     >
    //       <CircularProgress className={classes.circularProgressBackDrop} />
    //       <Typography className={classes.typographyBackdrop}>
    //         Aguarde...
    //       </Typography>
    //     </Grid>
    //   </Paper>
    // </Backdrop>
  );
};

export default LoadingDialog;
